/**
 * 语音对讲（五期·十七）纯函数：语音确认门固定词 + 播报截断策略。
 * 放 shared 的原因：固定词表是"协议级约定"，未来 agent 侧放心快通道要共用同一张表，防两端不一致。
 * 铁律：宁严勿宽——只有整句命中固定词才算数，绝不做包含式模糊匹配（防正常说话误触发确认）。
 */
/** 语音确认门：ASR 整句命中固定词 → approve/reject；其余一律 null（当普通对话处理）。 */
export function matchVoiceConfirm(raw) {
    // 归一化：去空白和句尾标点语气词，只留核心词
    const t = raw.replace(/[\s，。！？!?,、.~～…嗯啊呀哦哈嘛吗的呢]+/g, '');
    if (!t)
        return null;
    if (/^(?:确认(?:执行)?|同意|可以|行)吧?$|^(?:干|执行)吧$/.test(t))
        return 'approve';
    if (/^(?:取消|算了|不干了?|别做了?|别|停下?)吧?$/.test(t))
        return 'reject';
    return null;
}
/**
 * 播报策略：短回复全文播；超长只播首句 + 提示尾（防长汇报念一分钟）。
 * 首句按中文句读/换行切；首句本身超长则硬截 maxLen。
 */
export function voiceBroadcast(text, maxLen = 150) {
    const clean = text.trim();
    if (clean.length <= maxLen)
        return clean;
    const m = clean.match(/^[\s\S]*?[。！？!?\n]/);
    const first = m ? m[0].replace(/\n/g, '，').trim() : '';
    const head = first && first.length <= maxLen ? first : clean.slice(0, maxLen);
    return `${head.replace(/[，、\s]+$/, '')}。细节我放手机上了`;
}
